<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Detalhes da resposta"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary"
               link
               @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading">
      <px-resposta-detalhes-basico
        :resposta="resposta"
        @update="onUpdate"/>
      <px-resposta-detalhes-tabela-preco :resposta="resposta" @updated="onUpdate"/>
      <px-resposta-detalhes-tab :resposta="resposta"/>
    </div>
  </div>
</template>

<script>
import { DetalheFornecedorUtils } from 'px-components';
import RespostaDetalhesBasico from './RespostaDetalhesBasico.vue';
import RespostaDetalhesTabelaPreco from './RespostaDetalhesTabelaPreco.vue';
import RespostaDetalhesTab from './RespostaDetalhesTab.vue';
import RespostaService from '../resposta-service';

export default {
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    cotacaoIdProp: {
      type: [String, Number],
    },
    respostaIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      resposta: {},
      cotacaoId: null,
      respostaId: null,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Cotações',
          to: '/cotacoes',
        },
        { text: 'Respostas' },
        { text: 'Detalhes' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({
        name: 'main.cotacoes.respostas',
        params: {
          id: this.cotacaoId,
        },
      });
    },
    getResposta() {
      this.loading = true;
      RespostaService.getResposta(this.cotacaoId, this.respostaId)
        .then((response) => {
          this.resposta = response.data;
          this.buildFornecedor();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildFornecedor() {
      const { detalhesFornecedores } = this.resposta.cotacao;
      const { fornecedor } = this.resposta;
      const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);
      this.resposta.fornecedor = {
        ...fornecedor,
        codigoInterno: detalhe.codigoInterno,
        pessoa: {
          ...fornecedor.pessoa,
          nome: detalhe.nome || fornecedor.pessoa.nome,
        },
      };
    },
    onUpdate() {
      this.getResposta();
      this.$emit('change');
    },
  },
  created() {
    if (this.isModalView) {
      this.breadcrumbs = [];
    }
    this.cotacaoId = this.cotacaoIdProp || this.$route.params.id;
    this.respostaId = this.respostaIdProp || this.$route.params.idResposta;
    this.getResposta();
  },
  components: {
    pxRespostaDetalhesBasico: RespostaDetalhesBasico,
    pxRespostaDetalhesTabelaPreco: RespostaDetalhesTabelaPreco,
    pxRespostaDetalhesTab: RespostaDetalhesTab,
  },
};
</script>
